import { FUNKO_STICKER_TYPES } from "../constants/index.js";
import type { FunkoStickerType } from "../types/index.js";

/** Starting vocabulary supplied by the inventory operators. */
export const FUNKO_FEATURES = [
  "8-Bit", "Blacklight", "Bloody", "Chrome", "Deco - Color-Gradient", "Deco",
  "Diamond Collection", "Flocked", "Glitter", "Glow-in-the-Dark", "Holographic",
  "Light Up", "Metallic", "Red", "Retro", "Scented", "Soft Touch", "Sound Activated",
  "Translucent", "Porcelain", "Marble", "Die Cast",
] as const;
export const FEATURE_NAME_MAX_LENGTH = 100;
export const FEATURE_SELECTION_MAX_ITEMS = 50;
const aliases: Record<string, string> = { glow: "Glow-in-the-Dark", diamond: "Diamond Collection", common: "Common", exclusive: "Exclusive" };
export function normalizeFeatureName(value: string): string {
  const name = value.trim().replace(/\s+/g, " ");
  return aliases[name.toLowerCase()] ?? FUNKO_FEATURES.find(feature => feature.toLowerCase() === name.toLowerCase()) ?? name;
}
export function normalizeFunkoFeatures(values: readonly string[]): string[] {
  if (values.length > FEATURE_SELECTION_MAX_ITEMS) throw new Error("Select at most 50 Features.");
  const unique = new Map<string, string>();
  for (const value of values) {
    if (/[|\u0000-\u001f\u007f]/.test(value)) throw new Error("Features cannot contain control characters or |.");
    const name = normalizeFeatureName(value);
    if (!name || name.length > FEATURE_NAME_MAX_LENGTH) throw new Error("Features must contain 1–100 characters.");
    if (!unique.has(name.toLowerCase())) unique.set(name.toLowerCase(), name);
  }
  return [...unique.values()];
}
/** Legacy enum column remains constrained; new/custom names live in Features. */
export function legacyStickerFromFeatures(values: readonly string[]): FunkoStickerType | null {
  for (const name of values) {
    const match = FUNKO_STICKER_TYPES.find(type => normalizeFeatureName(type).toLowerCase() === name.toLowerCase());
    if (match) return match;
  }
  return null;
}
